import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// "מחיקת תמונה" confirmation, shown when the customer clicks an attached image
const DeleteImageDialog = ({ deleteConfirm, handleDeleteCancel, handleDeleteConfirm }) => (
  <Dialog open={deleteConfirm.open} onClose={handleDeleteCancel} dir="rtl">
    <DialogTitle>מחיקת תמונה</DialogTitle>
    <DialogContent>
      <DialogContentText>
        האם אתה בטוח שברצונך למחוק את התמונה?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleDeleteCancel} color="primary">
        ביטול
      </Button>
      <Button onClick={handleDeleteConfirm} color="error" autoFocus>
        מחק
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteImageDialog;
